import axiosInstance from "../../utils/axiosInstance";

const getHoleOutPrices = async (params) => {
  const response = await axiosInstance.get(
    `hole-out-price?limit=${params.pageSize}&skip=${
      (params.current - 1) * params.pageSize
    }&key=${params.key}&status=${params.status}`
  );
  return response.data.data;
};

const getHoleOutPrice = async (id) => {
  const response = await axiosInstance.get(`hole-out-price/${id}`);
  return response.data.data;
};

const createHoleOutPrice = async (data) => {
  const response = await axiosInstance.post(`hole-out-price`, data);
  return response.data.data;
};

const updateHoleOutPrice = async (params) => {
  const response = await axiosInstance.put(`hole-out-price/${params.id}`, params.data);
  return response.data.data;
};

const deleteHoleOutPrice = async (params) => {
  const response = await axiosInstance.delete(`hole-out-price/${params.id}`);
  return response.data.data;
};

const updateHoleOutPriceStatus = async (params) => {
  const response = await axiosInstance.put(`hole-out-price/${params.id}`, params.data);
  return response.data.data;
};

const holeOutPriceService = {
  getHoleOutPrices,
  updateHoleOutPrice,
  createHoleOutPrice,
  updateHoleOutPriceStatus,
  getHoleOutPrice,
  deleteHoleOutPrice,
};

export default holeOutPriceService;
